import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Check1"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.77354 8.41975C1.54424 8.1875 1.54424 7.81094 1.77354 7.57869L2.60395 6.73763C2.83326 6.50538 3.20504 6.50538 3.43435 6.73763L6.34076 9.68133L12.5688 3.37341C12.7981 3.14116 13.1699 3.14116 13.3992 3.37341L14.2296 4.21446C14.4589 4.44672 14.4589 4.82327 14.2296 5.05552L6.75596 12.625C6.52665 12.8573 6.15487 12.8573 5.92556 12.625L1.77354 8.41975Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var check1 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { check1 as default };
